import React from 'react';
import './PlanTierLabel.css';

/** Small plan badge (Pro / Team) — visibility only, does not hide features. */
export default function PlanTierLabel({ tier = 'Pro', className = '' }) {
  const normalized = String(tier || 'Pro').trim();
  const key = normalized.toLowerCase();
  return (
    <span className={`plan-tier-label plan-tier-label--${key} ${className}`.trim()}>
      {normalized}
    </span>
  );
}
